import React from 'react';
import { Icon } from '@99designs/frontend-components/components/Icon';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { Role } from '../../consts';
import { Site } from '../../lib/Site';
import urls from '../../urls';
import {
    OnsiteMessages,
    defaultUrls as defaultMessageUrls,
} from '../OnsiteMessages/OnsiteMessages';
import { OnsiteNotifications } from '../OnsiteNotifications';
import TopLevelNavigationDropdownItem from '../TopLevelNav/TopLevelNavigationDropdownItem';
import TopLevelNavigationItem from '../TopLevelNav/TopLevelNavigationItem';
import NotificationsIcon from './NotificationsIcon';
import StaticSupportNavigationDropdownItemCustomer from './StaticSupportNavigationDropdownItemCustomer';
import SupportMenu from './SupportMenu';

interface Props {
    role: Role;
    focused: boolean;
    site: Site;
    isStaticTemplate: boolean;
}

function PhoneLabel({ site }: { site: Site }) {
    return <FormattedMessage message="{phone}" values={{ phone: site.get('phone.support') }} />;
}

function MaybePhoneLabelTooltip({ site }: { site: Site }) {
    // TODO - Reintroduce Tooltip :shrug:
    return <PhoneLabel site={site} />;
}

export default function SecondaryNavigation({ role, focused, site, isStaticTemplate }: Props) {
    if (focused) return null;

    const attributes: { [index: string]: any } = {};
    attributes.title = site.get('phone.office_hours') || null;

    if (site.get('phone.office_hours')) {
        attributes['data-global-nav-tooltip'] = true; // FIXME: needs non-jquery tooltip
    }

    return (
        <div className="site-header__item site-header__item--secondary-navigation">
            <div className="top-level-nav">
                {role === 'contest-holder' && (
                    <React.Fragment>
                        {isStaticTemplate && (
                            <StaticSupportNavigationDropdownItemCustomer site={site} />
                        )}
                        {!isStaticTemplate && (
                            <TopLevelNavigationDropdownItem
                                label={__('Support')}
                                url="/help"
                                align="right"
                                additionalClasses={[
                                    'top-level-nav__item--first',
                                    'top-level-nav__item--support',
                                ]}
                            >
                                <SupportMenu site={site} />
                            </TopLevelNavigationDropdownItem>
                        )}
                    </React.Fragment>
                )}
                {role === 'designer' && (
                    <TopLevelNavigationItem
                        label={__('Help Center')}
                        additionalClasses={[
                            'top-level-nav__item--first top-level-nav__item--support',
                        ]}
                        url="/help"
                        linkAttributes={{ target: '_blank' }}
                    />
                )}
                {role !== 'logged-out' && (
                    <React.Fragment>
                        {isStaticTemplate && (
                            <div className="top-level-nav__item">
                                <a
                                    className="top-level-nav__item__link top-level-nav__item--onsite-messages-icon"
                                    href="/messages"
                                    data-globalnav-messages-dropdown
                                >
                                    <Icon type="mail-4" variations={['inline']} />
                                </a>
                            </div>
                        )}
                        {!isStaticTemplate && (
                            <div className="top-level-nav__item">
                                <OnsiteMessages urls={defaultMessageUrls} />
                            </div>
                        )}
                        {isStaticTemplate && <NotificationsIcon />}
                        {!isStaticTemplate && (
                            <div className="top-level-nav__item">
                                <OnsiteNotifications urls={urls} />
                            </div>
                        )}
                    </React.Fragment>
                )}
                {role === 'logged-out' && site.get('phone.support') && (
                    <React.Fragment>
                        {isStaticTemplate && (
                            <TopLevelNavigationItem
                                attributes={attributes}
                                label={<PhoneLabel site={site} />}
                                url="/help"
                                icon="phone-1"
                                iconVariations={['hidden-for-special-breakpoint']}
                            />
                        )}
                        {!isStaticTemplate && (
                            <TopLevelNavigationItem
                                label={<MaybePhoneLabelTooltip site={site} />}
                                url="/help"
                                icon="phone-1"
                                iconVariations={['hidden-for-special-breakpoint']}
                            />
                        )}
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}
